import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-news-detail-demo-one',
  templateUrl: './news-detail-demo-one.component.html',
  styleUrls: ['./news-detail-demo-one.component.scss']
})
export class NewsDetailDemoOneComponent implements OnInit {

  origiImg: any;

  constructor() { }

  ngOnInit(): void {
  }

}
